import PageHeader from "@/components/common/PageHeader";
import { Box } from "@mui/system";
import { FC } from "react";
import PurchaseItemTable from "./components/PurchaseItemtable";

const PurchaseItemManager: FC= () => {
return (
    <Box sx ={{backgroundColor : 'background.default',
        px: {xs:2, md:3, lg:4}
    }}>
    <PageHeader title= 'Administrador de conceptos de pago' description="Visualiza y gestiona los conceptos de pago desde un solo lugar"/>
    <PurchaseItemTable/>
    </Box>
)
}

export default PurchaseItemManager